import store from '@/store'
import _axios, { get, post } from '@/lin/plugin/axios'
import { saveTokens } from '../util/token'

export default class User {
  static register(user) {
    return _axios({
      method: 'post',
      url: 'cms/user/register',
      data: {
        email: user.email,
        username: user.username,
        password: user.password,
        group_ids: user.groupIds,
        confirm_password: user.confirmPassword,
      },
      handleError: true,
    })
  }

  static async getToken(username, password, captcha) {
    const result = await _axios({
      url: 'admin/login/doLogin',
      method: 'POST',
      data: {
        username,
        password,
        vercode: captcha,
      },
    })
    if (result?.data?.token) {
      saveTokens(result.data.token, result.data.token)
    }
    return result
  }

  static async getInformation() {
    const info = await get('admin/index/getBaseInfo')
    const storeUser = store.getters.user === null ? {} : store.getters.user
    return { ...storeUser, ...info.data }
  }

  static async getPermissions() {
    const info = await get('admin/index/getBaseInfo')
    const storeUser = store.getters.user === null ? {} : store.getters.user
    return { ...storeUser, ...info.data }
  }

  static async loginOut() {
    await get('admin/login/loginOut')
  }

  static updatePassword({ old_password, new_password, confirm_password }) {
    return post('admin/manager/updatePassword', {
      new_password,
      confirm_password,
      old_password,
    })
  }
}
